import { Grid } from "@mui/material";
import { SiteHeader } from "src/containers/SiteHeader/SiteHeader";
import { Footer } from "../../containers/Footer/Footer";
import { Hero } from "./containers/Hero/Hero";
import { Overview } from "./containers/Overview/Overview";
import { Challenges } from "./containers/Challenges/Challenges";
import { DevelopmentFlow } from "./containers/DevelopmentFlow/DevelopmentFlow";
import { TeamComposition } from "./containers/TeamComposition/TeamComposition";
import { Pricing } from "./containers/Pricing/Pricing";
import { Solutions } from "./containers/Solutions/Solutions";
import { Cta } from "./containers/Cta/Cta";
import { useEffect } from "react";

export const TasPage = () => {
  // ひとまず暫定でタイトルを設定
  // MEMO: 他のメタタグも含め、 SSG で設定したい
  useEffect(() => {
    document.title = "Technical Assist Service (TAS) | 株式会社テクノスタンダード";
  }, []);

  return (
    <Grid
      container
      className="TasPage"
      sx={{
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        minWidth: {
          md: "768px",
          xs: "374px",
        },
      }}
    >
      <SiteHeader />
      <Hero />
      <Overview />
      <Challenges />
      <DevelopmentFlow />
      <TeamComposition />
      <Pricing />
      <Solutions />
      <Cta />
      <Footer />
    </Grid>
  );
};
